import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCoverImageUrl, formatNumber } from '@utils/helpers';

function DramaCard({ drama, isComingSoon = false, onOpenModal }) {
    const navigate = useNavigate();
    const [imageFailed, setImageFailed] = useState(false);

    const coverUrl = getCoverImageUrl(drama);
    const viewCount = formatNumber(drama.playCount || 0);

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (isComingSoon) return;

        // If play button clicked, go directly to player
        if (e.target.closest('.play-btn')) {
            navigate(`/player?bookId=${drama.id || drama.bookId}&title=${encodeURIComponent(drama.name || drama.bookName)}`);
        } else {
            // Otherwise open modal
            onOpenModal && onOpenModal(drama);
        }
    };

    const handleImageError = () => {
        setImageFailed(true);
    };

    return (
        <div
            className="drama-card fade-in"
            data-book-id={drama.id || drama.bookId}
            onClick={handleClick}
            style={{ cursor: isComingSoon ? 'default' : 'pointer' }}
        >
            <div className="drama-poster">
                {coverUrl && !imageFailed ? (
                    <>
                        <img
                            src={coverUrl}
                            alt={drama.name || drama.bookName}
                            loading="lazy"
                            decoding="async"
                            onError={handleImageError}
                        />
                        <div className="drama-poster-fallback" style={{ display: 'none' }}>
                            <i className="fas fa-film"></i>
                        </div>
                    </>
                ) : (
                    <div className="drama-poster-fallback">
                        <i className="fas fa-film"></i>
                    </div>
                )}
                {!isComingSoon && (
                    <div className="drama-overlay">
                        <button className="play-btn">
                            <i className="fas fa-play"></i>
                        </button>
                    </div>
                )}
            </div>

            <h3 className="drama-title-outside">{drama.name || drama.bookName}</h3>
        </div>
    );
}

export default DramaCard;
